export default __webpack_public_path__ + "static/2-88ec295d10026b0114eb24bd66b8004a.jpeg";